<template>
	<div class="contact-page" :class="{ 'menu-open': menuOpen }" ref="contactPage">
		<!-- Header组件 -->
		<Header
			:showLogo="true"
			theme="dark"
			:fixed="true"
			:showBorder="isScrolled"
			backgroundColor="transparent"
			@menu-open="menuOpen = true"
			@menu-close="menuOpen = false"
			iconColor="white"
			:logoShrink="isScrolled"
		/>

		<!-- 顶部横幅 -->
		<div class="top_box">
			<div class="top-content" style="margin-top: 400rem;">
				<p class="top-title font-apercu-medium">Contact</p>
				<p class="top-desc font-apercu-medium" style="text-align: left;text-align: justify;width:438rem;">We love talking to people. Tell us about your space, your brief, or simply have a wee chat with us, you will be suprised.</p>
				<p class="top-desc font-apercu-medium" style="text-align: left;text-align: justify;"></p>
			</div>
		</div>

		<!-- 底部联系信息 -->
		<div class="contact-bottom">
			<!-- 第一行 -->
			<div class="contact-row">
				<div class="contact-left">
					<div class="info-row">
						<div class="info-label font-apercu-medium">DON'T BE A STRANGER.</div>
					</div>
					<div class="mailing-content">
						<p class="mailing-desc font-apercu-medium" style="margin-bottom: 0rem;line-height: 20rem;width: 344rem;">
							New pieces, studio happenings, and the
						</p>
						<p class="mailing-desc font-apercu-medium" style="line-height: 20rem;width: 344rem;">
							occasional bit of nonsense we're usually up to.
						</p>
						<div class="email-form font-apercu-medium" style="width: 344rem;">
							<input type="email" v-model="email" placeholder="Your Email Address" class="email-input font-apercu-medium"
								@keyup.enter="handleSubmit" />
							<button class="submit-btn font-apercu-medium" @click="handleSubmit">
								<span class="submit-text">[Submit]</span>
							</button>
						</div>
					</div>
				</div>

				<div class="contact-right">
					<div class="info-row">
						<div class="info-label font-apercu-medium">GENERAL ENQUIRES</div>
						<div class="info-value font-apercu-medium" style="line-height: 20rem;">
							<p>info@den-holm.com</p>
							<p>+61 422 875 261</p>
						</div>
					</div>
				</div>
			</div>

			<!-- 第二行 -->
			<div class="contact-row">
				<div class="contact-left">
					<div class="info-row">
						<div class="info-label font-apercu-medium">INSTAGRAM</div>
						<div class="info-value font-apercu-medium" style="line-height: 20rem;">
							<a href="https://www.instagram.com/den_holm/" target="_blank" class="contact-link">@den_holm</a>
							<a href="https://www.instagram.com/den_holmunited/" target="_blank" class="contact-link">@den_holmunited</a>
						</div>
					</div>
				</div>

				<div class="contact-right">
					<div class="info-row">
						<div class="info-label font-apercu-medium">STUDIO</div>
						<div class="info-value font-apercu-medium" style="line-height: 20rem;">
							<p>12 Fulton Street,Oakleigh South 3167</p>
							<p>Victoria, Australia</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部装饰 -->
		<div class="footer-deco">
			<img :src="flowerLogo" alt="Flower Logo" class="flower-logo" />
		</div>
	</div>
</template>

<script>
	import Header from '../components/Header.vue'
	import flowerLogo from '../assets/icon/logo_black.png'

	export default {
		name: 'ContactPage',
		components: {
			Header,
		},
		data() {
			return {
				menuOpen: false,
				email: '',
				flowerLogo,
				isScrolled: false,
			}
		},
		mounted() {
			// ✅ 监听容器自身的滚动事件，而不是 window
			const el = this.$refs.contactPage
			if (el) {
				el.addEventListener('scroll', this.handleScroll)
				// 初始检查
				this.handleScroll({ target: el })
			}
		},
		beforeDestroy() {
			const el = this.$refs.contactPage
			if (el) {
				el.removeEventListener('scroll', this.handleScroll)
			}
		},
		methods: {
			onMenuOpen() {
				this.menuOpen = true
			},
			onMenuClose() {
				this.menuOpen = false
			},
			onHeroChange() {},
			handleSubmit() {
				if (this.email) {
					console.log('Subscribing email:', this.email)
					this.email = ''
				}
			},
			handleScroll(e) {
				const target = e.target || this.$refs.contactPage
				const scrollTop = target.scrollTop || 0
				this.isScrolled = scrollTop > 50
			},
		},
	}
</script>

<style scoped>
	/* 基础样式 */
	.menu-open {
		/* ✅ 移除 brightness(0.7) 避免背景图变黑 */
		/* filter: brightness(0.7); */
		/* 保留 transition 以便将来可能的其他效果 */
		transition: filter 0.3s ease;
	}

	.contact-page {
		width: 100%;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		background: #ffffff;
		scrollbar-width: none;
		-ms-overflow-style: none;
	}
	.contact-page::-webkit-scrollbar {
		display: none;
	}

	/* ===== 顶部横幅 ===== */
	.top_box {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		z-index: 1;
		height: 734rem;
		max-height: 734rem;
		background-image: url('../assets/contact/contact1.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		margin-top: -123rem;
	}

	.top-content {
		text-align: center;
		color: #ffffff;
		max-width: 800rem;
		padding: 0 40rem;
	}

	.top-title {
		font-size: 24rem;
		font-weight: 700;
		margin: 0 0 28rem 0;
		height: 20rem;
		line-height: 20rem;
	}

	.top-sub {
		font-size: 16rem;
		font-weight: 500;
		margin: 0 0 12rem 0;
	}

	.top-desc {
		font-size: 16rem;
		font-weight: 500;
		margin: 0;
	}

	/* ===== 底部联系信息 ===== */
	.contact-bottom {
		display: flex;
		flex-direction: column;
		padding: 94rem 43rem 100rem 43rem;
		margin: 0 auto;
		gap: 60rem;
		position: relative;
		z-index: 1;
		background: #ffffff;
	}

	.contact-row {
		display: flex;
		width: 100%;
	}

	.contact-left {
		display: flex;
		width: 50%;
		flex-shrink: 0;
	}

	.mailing-label {
		width: 40%;
		flex-shrink: 0;
	}

	.label-title {
		font-size: 17rem;
		font-weight: 700;
		letter-spacing: -0.02em;
		line-height: 1.2;
		margin: 0;
	}

	.mailing-content {
		width: 40%;
		flex-shrink: 0;
	}

	.mailing-desc {
		font-size: 16rem;
		font-weight: 500;
		color: #000;
		margin: 0 0 30rem 0;
		line-height: 1.6;
	}

	.email-form {
		display: flex;
		align-items: baseline;
		gap: 4rem;
		border-bottom: 2rem solid #000;
		padding-bottom: 6rem;
	}

	.email-input {
		flex: 1;
		border: none;
		outline: none;
		font-size: 16rem;
		font-weight: 500;
		background: transparent;
		color: #000;
		padding: 0;
	}

	.email-input::placeholder {
		color: #999;
		font-weight: 400;
	}

	.submit-btn {
		background: none;
		border: none;
		font-size: 16rem;
		font-weight: 500;
		color: #000;
		cursor: pointer;
		padding: 0;
		transition: opacity 0.3s;
	}

	.submit-btn:hover {
		opacity: 0.6;
	}

	.contact-right {
		width: 50%;
		padding-left: 15%;
		flex-shrink: 0;
	}

	.info-row {
		display: flex;
		margin-bottom: 40rem;
	}

	.info-row:last-child {
		margin-bottom: 0;
	}

	.info-label {
		width: 250rem;
		flex-shrink: 0;
		font-size: 17rem;
		font-weight: 700;
		letter-spacing: -0.02em;
		line-height: 1.2;
	}

	.info-value {
		font-size: 16rem;
		font-weight: 500;
		color: #000;
		line-height: 1.8;
	}

	.info-value p {
		margin: 0;
	}

	.contact-link {
		display: block;
		color: #000;
		text-decoration: none;
		transition: opacity 0.3s;
	}

	.contact-link:hover {
		opacity: 0.6;
	}

	.footer-deco {
		text-align: center;
		padding: 60rem 0 100rem 0;
		position: relative;
		z-index: 1;
		background: #ffffff;
	}

	.flower-logo {
		width: 24rem;
		height: 30rem;
	}

	/* ===== 响应式 ===== */
	@media (max-width: 1024px) {
		.contact-bottom {
			padding: 60rem 30rem 30rem 30rem;
			gap: 40rem;
		}

		.contact-row {
			flex-direction: column;
		}

		.contact-left {
			width: 100%;
			flex-direction: column;
			margin-bottom: 30rem;
		}

		.mailing-label {
			width: 100%;
			margin-bottom: 20rem;
		}

		.mailing-content {
			width: 100%;
		}

		.contact-right {
			width: 100%;
			padding-left: 0;
		}

		.info-row {
			flex-direction: column;
			margin-bottom: 30rem;
		}

		.info-label {
			width: 100%;
			margin-bottom: 8rem;
		}
	}

	@media (max-width: 768px) {
		.top_box {
			height: 400rem;
			max-height: 400rem;
			padding-top: 60rem;
		}

		.top-title {
			font-size: 20rem;
			margin-bottom: 24rem;
		}

		.top-sub,
		.top-desc {
			font-size: 14rem;
		}

		.contact-bottom {
			padding: 40rem 20rem 20rem 20rem;
			gap: 30rem;
		}

		.mailing-desc {
			font-size: 14rem;
		}

		.email-input,
		.submit-btn {
			font-size: 14rem;
		}

		.info-value {
			font-size: 14rem;
		}

		.label-title,
		.info-label {
			font-size: 15rem;
		}
	}

	@media (max-width: 480px) {
		.top_box {
			height: 320rem;
			max-height: 320rem;
			padding-top: 50rem;
		}

		.top-title {
			font-size: 18rem;
			margin-bottom: 16rem;
		}

		.top-sub,
		.top-desc {
			font-size: 13rem;
		}

		.email-form {
			flex-wrap: wrap;
			gap: 8rem;
		}

		.flower-logo {
			width: 32rem;
		}
	}
</style>

